/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SharedPopularSearchesLink_popularSearchesLink = {
    readonly text: string | null;
    readonly path: string | null;
    readonly " $refType": "SharedPopularSearchesLink_popularSearchesLink";
};
export type SharedPopularSearchesLink_popularSearchesLink$data = SharedPopularSearchesLink_popularSearchesLink;
export type SharedPopularSearchesLink_popularSearchesLink$key = {
    readonly " $data"?: SharedPopularSearchesLink_popularSearchesLink$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedPopularSearchesLink_popularSearchesLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};
(node as any).hash = '2efa0c06bdb8e8b688963baa45fbfe44';
export default node;
